import React from 'react';
import UpcomingDriveListing from 'src/components/newRecruiterFlow/campus/upcomingDrives/UpcomingDriveListing';
const UpcomingDriveListingPage = () => {
	return (
		<div>
			<UpcomingDriveListing />
		</div>
	);
};

export default UpcomingDriveListingPage;
